import { ZButton } from "@/shared/components/button";
import type { BusinessOwnerForm } from "@/modules/third-party-risk/types/intake-form-v2";

// No descriptive label needed — just "Tier N"

interface ReviewBannerProps {
  businessOwnerForm: BusinessOwnerForm;
  onAccept: () => void;
  onReject: () => void;
  isLoading: boolean;
}

export function ReviewBanner({
  businessOwnerForm,
  onAccept,
  onReject,
  isLoading,
}: ReviewBannerProps) {
  const tierLabel = businessOwnerForm.tier
    ? `Tier ${businessOwnerForm.tier}`
    : null;

  return (
    <div
      className="w-full overflow-hidden"
      style={{
        border: "1px solid #BEDBFF",
        borderRadius: "8px",
      }}
    >
      {/* Top section — text content (Frame 7264) */}
      <div
        className="flex flex-col"
        style={{
          backgroundColor: "#EFF6FF",
          borderBottom: "1px solid #BEDBFF",
          padding: "16px",
          gap: "16px",
        }}
      >
        {/* Text block (Frame 7262) */}
        <div className="flex flex-col" style={{ gap: "4px" }}>
          <span
            style={{
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#0F172B",
            }}
          >
            Review Assessment Request from{" "}
            {businessOwnerForm.business_owner_email}
          </span>
          <span
            style={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#62748E",
            }}
          >
            Review the submitted details below. Accepting this request will
            calculate the risk tier and initiate the assessment process.
          </span>
        </div>
      </div>

      {/* Bottom section — tier + buttons (Frame 7265) */}
      <div
        className="flex items-center justify-between"
        style={{
          backgroundColor: "#EFF6FF",
          padding: "12px 16px",
        }}
      >
        {/* Left: Tier badge (Frame 7265 inner) */}
        <div className="flex items-center" style={{ gap: "16px" }}>
          {tierLabel && (
            <>
              <span
                style={{
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: "20px",
                  color: "#62748E",
                }}
              >
                Calculated Tier
              </span>
              <span
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "24px",
                  padding: "2px 12px",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#45556C",
                }}
              >
                {tierLabel}
              </span>
            </>
          )}
        </div>

        {/* Right: Buttons (Frame 7263) */}
        <div className="flex items-center" style={{ gap: "8px" }}>
          <ZButton
            color="primary"
            size="sm"
            style={{
              backgroundColor: "#006FEE",
              borderRadius: "6px",
              padding: "4px 8px",
              fontSize: "12px",
              lineHeight: "16px",
              fontWeight: 500,
              height: "24px",
              minHeight: "24px",
            }}
            onPress={onAccept}
            isLoading={isLoading}
          >
            Accept
          </ZButton>
          <ZButton
            variant="bordered"
            size="sm"
            style={{
              borderColor: "#F31260",
              color: "#F31260",
              backgroundColor: "#FFFFFF",
              borderRadius: "6px",
              padding: "4px 8px",
              fontSize: "12px",
              lineHeight: "16px",
              fontWeight: 500,
              height: "24px",
              minHeight: "24px",
            }}
            onPress={onReject}
            isDisabled={isLoading}
          >
            Reject
          </ZButton>
        </div>
      </div>
    </div>
  );
}
